module.exports = __webpack_public_path__ + "img/6.7a2d79fc.png";